import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { AltTextPipe } from 'render/render-shared/alt-text/alt-text.pipe';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceImageRenderComponent } from './piece-image-render.component';


export const pieceImageRenderModuleEntryComponents = [
  PieceImageRenderComponent
];

@NgModule({
  imports: [
    AltTextPipe,
    LazyLoadModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceImageRenderModuleEntryComponents,
  exports: [PieceImageRenderComponent]
})
export class PieceImageRenderModule {}

export default pieceImageRenderModuleEntryComponents;
